import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Sprout, Heart, Gift, EyeOff, Eye, Calendar, Radio, HeartHandshake, Smartphone } from "lucide-react";
import api from "@/lib/api";
import { useFeature } from "@/contexts/FeaturesContext";

/* ── Portofelul de Semințe (17.12) ── */

export function SeedWallet() {
  const enabled = useFeature("seed_wallet");
  const [p, setP] = useState(null);
  const [ledger, setLedger] = useState([]);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (!enabled) return;
    api.get("/me/progress").then((r) => setP(r.data)).catch(() => {});
    api.get("/me/ledger").then((r) => setLedger(r.data.items || [])).catch(() => {});
  }, [enabled]);
  if (!enabled || !p) return null;
  return (
    <div className="card-premium p-6" data-section-key="acc_seedwallet" data-testid="seed-wallet">
      <div className="flex items-center justify-between mb-3">
        <h3 data-el="seedwallet_title" className="font-serif text-lg inline-flex items-center gap-2"><Sprout size={16} style={{ color: "var(--ct-link)" }} /> Semințele mele</h3>
        <Link to="/copacul-meu" className="text-xs" style={{ color: "var(--ct-link)" }}>Recompense →</Link>
      </div>
      <div className="flex gap-6">
        <div><p className="font-serif text-3xl" style={{ color: "var(--ct-link)" }}>{p.seeds_balance || 0}</p><p data-el="seedwallet_balance_label" className="text-[11px]" style={{ color: "var(--ct-text-dim)" }}>sold acum</p></div>
        <div><p className="font-serif text-3xl" style={{ color: "var(--ct-gold)" }}>{p.seeds_earned_total || 0}</p><p data-el="seedwallet_total_label" className="text-[11px]" style={{ color: "var(--ct-text-dim)" }}>adunate în total</p></div>
      </div>
      {ledger.length > 0 && (
        <>
          <button type="button" onClick={() => setOpen((o) => !o)} className="text-xs mt-4" style={{ color: "var(--ct-link)" }}>{open ? "Ascunde istoricul" : "Vezi istoricul"}</button>
          {open && (
            <div className="mt-3 space-y-1.5 max-h-56 overflow-auto">
              {ledger.slice(0, 30).map((l, i) => (
                <div key={i} className="flex items-center justify-between text-xs py-1.5 border-b" style={{ borderColor: "var(--ct-border)" }}>
                  <span style={{ color: "var(--ct-text-muted)" }}>{(l.reason || "").replace(/^action:|:/g, " ").trim() || "mișcare"}</span>
                  <span style={{ color: l.delta > 0 ? "var(--ct-emerald)" : "var(--ct-text-dim)" }}>{l.delta > 0 ? "+" : ""}{l.delta}</span>
                </div>
              ))}
            </div>
          )}
        </>
      )}
    </div>
  );
}
